/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react';
import clsx from 'clsx';
import { HeaderNotificationsMenu, ThemeModeSwitcher } from '../../../partials';
import { KTIcon } from '../../../helpers';
import { ShiftControls } from './ShiftControls';

const itemClass = 'ms-1 ms-md-4';
const btnClass = 'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px';
const btnIconClass = 'fs-2';

const Topbar: FC = () => {
  const [unreadCount, setUnreadCount] = useState(0);

  return (
    <div className='d-flex flex-shrink-0'>
      {/* --- Shift/Break Controls --- */}
      <div className='d-flex align-items-center ms-3'>
        <ShiftControls />
      </div>

      {/* --- Notifications --- */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx('position-relative', btnClass)}
        >
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          
          {unreadCount > 0 && (
            <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
          )}
        </div>

        <HeaderNotificationsMenu setUnreadCount={setUnreadCount} />
      </div>
    </div>
  );
};

export { Topbar };
